<div class="radios" [ngClass]="{'radios--inline': titleDisplay === 'inline'}">
  <div class="radios__title">
    <ng-content></ng-content>
  </div>
  <div class="radios__group" [ngClass]="{
    'radios__group--block': block,
    'radios__group--row': groupDirection === 'row'}">
    <div class="radios__radio-input" *ngFor="let radio of radioInputs">
      <input type="radio" [name]="radio.name" [value]="radio.value" [id]="radio.id" [formControl]="formControlProperty"
        [checked]="radio.value === defaultChecked" (click)="selectOption(radio)">
      <label class="radios__label" [for]="radio.id">{{radio.label}}
        <lib-tooltip *ngIf="radio.tooltip">
          {{radio.tooltip}}
        </lib-tooltip>
      </label>
    </div>
  </div>
  <lib-alert-message *ngIf="!!error" type="danger">{{error}}</lib-alert-message>
</div>
